/**
 * Converts linebreaks within a string into HTML line-breaks
 * @param {string} text - A text to be transformed
 * @return {string} The transformed text
 */
export default function lineBreakFilter(text) {
    return text.replace(/\n\r?/g, '<br>');
}
